import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import HelpIcon from '../../HelpIcon';

const AdminFileStatusesListHeader = ({
  orderBy,
  order,
  handleChangeOrder,
}) => {
  const changeOrder = (e, field) => {
    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  };

  const intl = useIntl();

  return (
    <tr>
      <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'name'); }}>
          {intl.formatMessage({ defaultMessage: 'Name' })}
          {' '}
          {orderBy === 'name' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Files' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Default' })}
        <HelpIcon>
          {intl.formatMessage({ defaultMessage: 'Default status for all uploaded files' })}
        </HelpIcon>
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Action' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

AdminFileStatusesListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default AdminFileStatusesListHeader;
